import React from "react";
import Header from "../../../layouts/AuthLayout/header/header";
import SampleCategoriesSection from "./stock-categories-section";

export default function StockCategoriesPage() {
  return (
    <>
      <Header />
      <SampleCategoriesSection />
    </>
  );
}
